'use strict';

angular.module('portal.login')
    .controller('ResetPassword', ['$q', '$scope', '$state', '$stateParams', '$rootScope', '$window', '$timeout', 'localStorageService', 'Users', 'Authentication', 'Enterprise', 'EnterpriseLoginCriteria', 'Utils', 'Session', function ($q, $scope, $state, $stateParams, $rootScope, $window, $timeout, localStorageService, Users, Authentication, Enterprise, EnterpriseLoginCriteria, Utils, Session) {
        $scope.loading = true;
        $scope.loadingRequirements = true;
        $scope.resetting = false;
        $scope.success = false;
        $scope.disablePasswordLogin = false;
        $scope.has_identity_provider = false;
        $scope.failedMessages = [];
        $scope.login_criteria = {};
        $scope.parameters = { enterpriseID: $rootScope.enterpriseID };
        $scope.reset_object = { enterprise_id: $rootScope.enterpriseID, is_public: true};
        $scope.tokenID = $stateParams.token;
        $scope.unauthorized = ($scope.tokenID == null || $scope.tokenID == "");
        $scope.cameFromProfile = $stateParams.cameFromProfile;
        $scope.expired = false;
        $scope.requirements = {};
        $scope.user_id = null;
        $scope.promises = [];
        $scope.locked = false;

        $scope.promises.push(EnterpriseLoginCriteria.get({ enterpriseID: $rootScope.enterpriseID }).then(function (result) {
            $scope.enterpriseLoginCriteria = result;
        }));

        // Logout any existing session first
        if ($scope.cameFromProfile != 'true') {
            Utils.DeleteSessionCookie(true);
            Session.expireSession(true);
            localStorageService.remove('portalAuthorizationData');
            $rootScope.userAccount = null;
        }

        if (!$scope.unauthorized) {
            // Make sure we have the enterprise details
            if ($rootScope.enterprise != null) {
                $scope.enterprise = $rootScope.enterprise;
            } else {
                $scope.promises.push(Enterprise.getLess({
                    enterpriseID: $rootScope.enterpriseID, isPortal: true }).then(function (result) {
                    $scope.enterprise = result;
                }));
            }

            // Get the auth token, and specifically the user ID we're here for
            $scope.promises.push(Users.getResetToken({ key: $scope.tokenID, enterprise_id: $rootScope.enterpriseID }).then(function (result) {
                if (result != null) {
                    if (result.success != true) {
                        $scope.failedMessages.push(result.message);
                        $scope.unauthorized = true;
                    } else {
                        $scope.user_id = result.user_id;
                        $scope.reset_object.user_id = result.user_id;
                        $scope.reset_object.username = result.user_name;
                        $scope.suspended = result.suspended;
                        $scope.suspended_on = result.suspended_on;
                        $scope.unsuspended = result.unsuspended;
                        $scope.has_identity_provider = result.has_identity_provider;
                        // Get the strictest access control settings for this user
                        $scope.promises.push(Users.getPasswordRequirements({ user_id: result.user_id }).then(function(requirements) {
                            if (requirements != null) {
                                $scope.requirements = requirements;
                            }
                            $scope.loadingRequirements = false;
                        }));
                    }
                } else {
                    $scope.failedMessages.push("Error verifying reset link.");
                    $scope.unauthorized = true;
                }
            }));

            // Get the login criteria
            $q.all($scope.promises).then(function () {
                //Determine if the account is suspended and is still locked out
                if ($scope.suspended && $scope.suspended_on && $scope.enterpriseLoginCriteria && $scope.enterpriseLoginCriteria.minutes_locked) {
                    var nowTimestamp = function () {
                        return (typeof Date.now === 'function') ? Date.now() : (new Date()).getTime();
                    };
                    var parseSuspendedOnTimestamp = function (value) {
                        if (angular.isDate(value)) {
                            return value.getTime();
                        }

                        if (angular.isString(value)) {
                            var normalized = value.trim().replace(' ', 'T');
                            // Normalize higher-precision fractions (for example .NET "o" format) to milliseconds.
                            normalized = normalized.replace(/(\.\d{3})\d+(?=(Z|[+\-]\d{2}:\d{2})$)/i, '$1');
                            normalized = normalized.replace(/(\.\d{3})\d+$/, '$1');
                            var parsed = Date.parse(normalized);
                            if (!isNaN(parsed)) {
                                return parsed;
                            }

                            // Fallback for older/non-standard strings: treat as UTC when timezone is missing.
                            if (!/(Z|[+\-]\d{2}:\d{2})$/i.test(normalized)) {
                                return Date.parse(normalized + 'Z');
                            }

                            return parsed;
                        }

                        return new Date(value).getTime();
                    };

                    var suspendedOnTimestamp = parseSuspendedOnTimestamp($scope.suspended_on);

                    var lockExpiresAt = suspendedOnTimestamp + ($scope.enterpriseLoginCriteria.minutes_locked * 60000);
                    var timeDifference = lockExpiresAt - nowTimestamp();
                    if (timeDifference > 0) {
                        $scope.locked = true;

                        //Display the locked out time remaining
                        timeDifference = timeDifference / 1000;
                        var hrs = Math.floor(timeDifference / 3600);
                        var mins = Math.floor((timeDifference % 3600) / 60);
                        var secs = Math.floor(timeDifference % 60);
                        var result = "";

                        if (hrs > 0) {
                            result += "" + hrs + ":" + (mins < 10 ? "0" : "");
                        }

                        result += "" + mins + ":" + (secs < 10 ? "0" : "");
                        result += "" + secs;

                        $scope.countdown = result;
                            
                        $scope.onTimeout = function () {
                            var timeDifference = (lockExpiresAt - nowTimestamp()) / 1000;
                            if (timeDifference > 0) {
                                var hrs = Math.floor(timeDifference / 3600);
                                var mins = Math.floor((timeDifference % 3600) / 60);
                                var secs = Math.floor(timeDifference % 60);
                                var result = "";

                                if (hrs > 0) {
                                    result += "" + hrs + ":" + (mins < 10 ? "0" : "");
                                }

                                result += "" + mins + ":" + (secs < 10 ? "0" : "");
                                result += "" + secs;
                                $scope.countdown = result;

                                timer = $timeout($scope.onTimeout, 1000);
                            }
                            else {
                                //Countdown has passed, user can now reset their password to unsuspend their account
                                $timeout.cancel(timer);
                                $scope.locked = false;
                            }
                        }
                        //Recalculate the time remaining every second
                        var timer = $timeout($scope.onTimeout, 1000);
                        $scope.$on('$destroy', function () {
                            $timeout.cancel(timer);
                        });
                    }
                }
                $scope.loading = false;
            }).catch(function (response) {
                // handle error
            });  

            $scope.reset = function() {
                $scope.failedMessages = [];
                $scope.promises = [];
                var valid = true;
                
                // check password validity
                if ($scope.reset_object.confirm != $scope.reset_object.password) {
                    valid = false;
                    $scope.failedMessages.push("Passwords must match!");
                }
                if ($scope.requirements.numeric_chars && ($scope.reset_object.password.search(/^.*(?=.*\d).*$/) == -1)) {
                    valid = false;
                    $scope.failedMessages.push("Your password must contain at least one numeric character.");
                }
                if ($scope.requirements.uppercase && ($scope.reset_object.password.search(/^.*(?=.*[A-Z]).*$/) == -1)) {
                    valid = false;
                    $scope.failedMessages.push("Your password must contain at least one uppercase character.");
                }
                if ($scope.requirements.special_chars && ($scope.reset_object.password.search(/^.*[!@##\$%\^\&\*\(\)\?].*$/) == -1)) {
                    valid = false;
                    $scope.failedMessages.push("Your password must contain at least one special character.");
                }
                if ($scope.requirements.not_username && ($scope.reset_object.password == $scope.reset_object.username)) {
                    valid = false;
                    $scope.failedMessages.push("Your password and username cannot match.");
                }
                if ($scope.requirements.min_length > 0 && ($scope.reset_object.password.length < $scope.requirements.min_length)) {
                    valid = false;
                    $scope.failedMessages.push("Your password must be at least " + $scope.requirements.min_length + " characters long.");
                }
                if ($scope.requirements.number_of_passwords > 0) {
                    // Get history
                    $scope.resetting = true;
                    $scope.promises.push(Users.checkPasswordHistory({ user_id: $scope.user_id, pass: $scope.reset_object.password, top: $scope.requirements.number_of_passwords }).then(function (clear) {
                        if (!clear) {
                            valid = false;
                            if ($scope.requirements.number_of_passwords == 1) {
                                $scope.failedMessages.push("Your new password cannot match your last password.");
                            } else {
                                $scope.failedMessages.push("Your new password cannot match any of your last " + $scope.requirements.number_of_passwords + " passwords.");
                            }
                        }
                    }));
                }

                // Now do the save
                $q.all($scope.promises).then(function () {
                    if (valid) {
                        $scope.resetting = true;
                        Users.resetPassword($scope.reset_object).then(function(result) {
                            if (result != null) {
                                $scope.success = result.success;
                                if (result.messages != null) {
                                    $scope.failedMessages = result.messages;
                                }
                                if (result.success) {
                                    // saved new password, now log them in
                                    $scope.signature = { username: $scope.reset_object.username, pass: $scope.reset_object.password, isPortal: true };
                                    Authentication.login($scope.signature).then(function(response) {
                                        if (response != null) {
                                            if (response.user_id !== undefined && response.user_id.length) {
                                                if (response.redirect_url.indexOf('portal.') == 0) {
                                                    $state.go(response.redirect_url, { messages: ["New password saved"] });
                                                } else {
                                                    $window.location = response.redirect_url;
                                                }
                                            } else {
                                                $state.go('portal.menus.login', { messages: ["New password saved"] });
                                            }
                                        }
                                    });
                                } else {
                                    $scope.resetting = false;
                                }
                            } else {
                                $scope.resetting = false;
                            }
                        });
                    } else {
                        $scope.resetting = false;
                    }
                }).catch(function (response) {
                    // handle error
                });  
            }
        }

        $scope.cancel = function () {
            $scope.loading = true;
            $state.go('portal.menus.login', {});
        }

        $scope.returnToProfile = function () {
            $state.go('portal.menus.accountProfileNew');
        }
    }])
;
